import React from "react";
import { Check } from "lucide-react";
import { Input } from "../../../ui/input";
import { Button } from "../../../ui/button";
import { RECIPE_FIELDS } from "../../../../utils/sessionRecipes";
import { chip } from "./MusclesDetail";

const RecipeSaveDetail = ({ form, onName, onToggleField, onSave, saving }) => {
  if (!form) return null;
  return (
    <>
      <div className="space-y-2">
        <label htmlFor="recipe-name" className="text-xs font-semibold text-muted-foreground">
          Name
        </label>
        <Input
          id="recipe-name"
          value={form.name}
          onChange={(e) => onName(e.target.value)}
          placeholder="e.g. Lunchtime kettlebell"
          className="h-10 bg-background/50 text-sm"
        />
      </div>
      <div className="space-y-2">
        <p className="text-xs font-semibold text-muted-foreground">
          What should it set?
        </p>
        <p className="text-xs leading-snug text-muted-foreground">
          Ticked settings are saved as they are now. Everything else keeps
          following your profile.
        </p>
        <div className="flex flex-wrap gap-1.5">
          {RECIPE_FIELDS.map((field) => {
            const on = form.pinned.includes(field.key);
            return (
              <button
                key={field.key}
                type="button"
                aria-pressed={on}
                onClick={() => onToggleField(field.key)}
                className={chip(on)}
              >
                {on && <Check className="-ml-0.5 mr-1 inline h-3.5 w-3.5 align-[-2px]" />}
                {field.label}
              </button>
            );
          })}
        </div>
      </div>
      <Button
        type="button"
        className="h-11 w-full"
        disabled={!form.name.trim() || saving}
        onClick={onSave}
      >
        {saving ? "Saving..." : "Save recipe"}
      </Button>
    </>
  );
};

export default RecipeSaveDetail;
